import { externalSqlStorageAdapter } from './adapters/externalSqlStorageAdapter';
import { localStorageAdapter } from './adapters/localStorageAdapter';
import { remoteApiAdapter } from './adapters/remoteApiAdapter';
import { sqliteStorageAdapter } from './adapters/sqliteStorageAdapter';
import type { StorageAdapter, StorageModeInfo } from './storageAdapter';
import { getProductModeInfo } from './productMode';
import { isDesktopRuntime } from './rustCalculationEngine';

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').trim();
const demoModeForced = import.meta.env.VITE_DEMO_MODE === 'true';
const productModeInfo = getProductModeInfo();
const desktopRuntime = isDesktopRuntime();
const productStorageMode =
  !desktopRuntime ? 'demo-local'
  : productModeInfo.mode === 'standalone' ? 'desktop-sqlite'
  : productModeInfo.mode === 'server-client' ? 'desktop-external-sql'
  : 'demo-local';

export const storageModeInfo: StorageModeInfo = {
  mode: apiBaseUrl && !demoModeForced ? 'remote-api' : productStorageMode,
  apiBaseUrl,
};

export const adapter: StorageAdapter =
  storageModeInfo.mode === 'remote-api'
    ? remoteApiAdapter
    : storageModeInfo.mode === 'desktop-sqlite'
    ? sqliteStorageAdapter
    : storageModeInfo.mode === 'desktop-external-sql'
    ? externalSqlStorageAdapter
    : localStorageAdapter;

export const isRemoteStorageEnabled = storageModeInfo.mode === 'remote-api';
